import { nanoid } from 'nanoid';

export const generateKey = () => {
    return nanoid();
};

export const truncateFileName = (fileName, maxLength = 30) => {
    if (!fileName) {
        return '';
    }

    const dotIndex = fileName.lastIndexOf('.');
    const extension = dotIndex !== -1 ? fileName.slice(dotIndex) : '';
    const name = dotIndex !== -1 ? fileName.slice(0, dotIndex) : fileName;

    if (name.length > maxLength) {
        return name.slice(0, maxLength) + '…' + extension;
    }

    return fileName;
};
